export enum TipoVeiculo {
  BITREM = 'BITREM',
  BITRENZAO = 'BITRENZÃO (9 EIXOS)',
  BITRUCK = 'BI-TRUCK',
  CARRETA = 'CARRETA',
  CARRETALS = 'CARRETA LS',
  MOTO = 'MOTO',
  RODOTREM = 'RODOTREM',
  SOCAVALOMECANICO = 'SÓ CAVALO MECANICO (4X2)',
  SOCAVALOMECANICOLS = 'SÓ CAVALO MECANICO LS',
  TOCO = 'TOCO',
  TOCO3QUARTOS = 'TOCO 3/4',
  TRITREM = 'TRITREM',
  TRUCK = 'TRUCK',
  UTILITARIO = 'UTILITÁRIO',
  VAN = 'VAN',
  VUC = 'VUC / HR',
  OUTROS = 'OUTROS',
}
